import { useState } from "react";
import { http } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export function ChangePasswordButton({ compact }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ cur: "", n1: "", n2: "" });
  const [busy, setBusy] = useState(false);
  const err = f.n1 && !/^\d{6}$/.test(f.n1) ? "6 haneli, sadece rakam" : f.n2 && f.n1 !== f.n2 ? "Şifreler eşleşmiyor" : "";
  const submit = async (e) => {
    e.preventDefault();
    if (err || !f.cur || !f.n1) return;
    setBusy(true);
    try {
      await http.post("/auth/change-password", { current_password: f.cur, new_password: f.n1 });
      toast.success("Şifreniz değiştirildi");
      setOpen(false); setF({ cur: "", n1: "", n2: "" });
    } catch (er) { toast.error(er?.response?.data?.detail?.toString() || "Değiştirilemedi"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="ghost" size="sm" onClick={() => setOpen(true)} className="text-slate-300" data-testid="change-password-btn" title="Şifre Değiştir">
        <KeyRound size={16} />{!compact && <span className="ml-1.5">Şifre</span>}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-sm" data-testid="change-password-dialog">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><KeyRound size={18} className="text-blue-400" /> Şifre Değiştir</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div><Label className="text-xs">Mevcut Şifre</Label>
              <Input type="password" autoComplete="current-password" value={f.cur} onChange={(e) => setF({ ...f, cur: e.target.value })} className="bg-slate-950/50 border-slate-700 mt-1" data-testid="cp-current" /></div>
            <div><Label className="text-xs">Yeni Şifre</Label>
              <Input type="password" inputMode="numeric" maxLength={6} autoComplete="new-password" value={f.n1} onChange={(e) => setF({ ...f, n1: e.target.value.replace(/\D/g, "") })} className="bg-slate-950/50 border-slate-700 mt-1" data-testid="cp-new" /></div>
            <div><Label className="text-xs">Yeni Şifre (Tekrar)</Label>
              <Input type="password" inputMode="numeric" maxLength={6} autoComplete="new-password" value={f.n2} onChange={(e) => setF({ ...f, n2: e.target.value.replace(/\D/g, "") })} className="bg-slate-950/50 border-slate-700 mt-1" data-testid="cp-new2" /></div>
            {err && <p className="text-xs text-red-400" data-testid="cp-error">{err}</p>}
            <DialogFooter>
              <Button type="submit" disabled={busy || !!err || !f.cur || !f.n1 || !f.n2} className="w-full bg-blue-600 hover:bg-blue-500" data-testid="cp-submit">Şifreyi Değiştir</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
